import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CommonBehaviorChangeService {
    private settingsSubject = new BehaviorSubject<any>(null);
    settings$ = this.settingsSubject.asObservable();

    constructor() {
    }

    /**
     * Updates the system settings with the provided data and notifies all observers.
     * @param {any} data - The new settings data to be applied to the system.
     */
    setSystemSettings(data: any) {
        this.settingsSubject.next(data);
    }
}
